export default "__VITE_ASSET__8P6s8T6___"